import { useState } from "react";
import { faqs } from "@/mocks/homeData";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full border-b border-background-200/70 bg-background-50 px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-6xl">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[0.9fr_1.4fr] lg:gap-14">
          <div>
            <p className="mb-2 flex items-center gap-2 text-xs font-medium text-primary-600 md:text-sm">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-question-line text-base" aria-hidden="true"></i>
              </span>
              模块 07 · 常见问题
            </p>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              关于黑料查询的常见问题
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              先弄清搜索方式与热度含义，再去翻线索，效率会高很多。下面是最常被问到的几个点。
            </p>
          </div>

          <div className="divide-y divide-background-200/80 border-y border-background-200/80">
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <div key={faq.q}>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 py-4 text-left md:py-5"
                  >
                    <span className="flex items-start gap-3">
                      <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-primary-100 font-heading text-xs font-bold text-primary-700">
                        {index + 1}
                      </span>
                      <span className="font-heading text-base font-semibold text-foreground-950 md:text-lg">
                        {faq.q}
                      </span>
                    </span>
                    <span
                      className={`flex h-6 w-6 shrink-0 items-center justify-center text-foreground-500 transition-transform ${
                        isOpen ? "rotate-180" : ""
                      }`}
                    >
                      <i className="ri-arrow-down-s-line text-xl" aria-hidden="true"></i>
                    </span>
                  </button>
                  {isOpen && (
                    <p className="animate-fade-up pb-5 pl-9 pr-2 text-sm leading-relaxed text-foreground-600 md:text-base">
                      {faq.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}